export default __webpack_public_path__ + "static/media/cookies.c0518ed1.svg";